<app-topbar></app-topbar>
<div class="content-container">
  <app-navbar></app-navbar>
  <div class="container-fluid">
    <h2 class="my-3">Personas</h2>

    <div class="btn-group mb-3">
      <button
        class="btn btn-primary"
        data-bs-toggle="modal"
        data-bs-target="#nuevoPersonaModal"
        id="btn-venta"
        (click)="limpiarModalAgregarPersona('venta')"
      >
        Agregar Nueva Venta
      </button>
      <button
        class="btn btn-success"
        data-bs-toggle="modal"
        data-bs-target="#nuevoPersonaModal"
        id="btn-persona"
        (click)="limpiarModalAgregarPersona('persona')"
      >
        Agregar Persona
      </button>
    </div>

    <app-persona-modal
      [sexos]="sexos"
      [estadosCiviles]="estadosCiviles"
      [nacionalidades]="nacionalidades"
      [parentescos]="parentescos"
      [tiposBeneficiarios]="tiposBeneficiarios"
      [planes]="planes"
      [obrasSociales]="obrasSociales"
      [revistas]="revistas"
      [provincias]="provincias"
      [tipoModal]="tipoModal"
    ></app-persona-modal>
    <app-vendedor-modal></app-vendedor-modal>
    <app-empresa-modal></app-empresa-modal>

    <div class="row filtros">
      <label class="me-2 mb-1">Busqueda de personas</label>
      <div class="col-md-7">
        <div class="form-group d-flex align-items-center">
          <input
            id="inputPersona"
            type="text"
            class="form-control me-2"
            style="flex: 0 0 60%"
            [(ngModel)]="termBusqueda"
            [readonly]="editando"
            placeholder="Escribe al menos 3 letras"
            (input)="onSearchInput()"
            (keydown)="handleKeyDown($event)"
          />
          <button
            class="btn btn-primary me-2"
            [disabled]="editando || termBusqueda.length < 3"
            (click)="buscarPersonas()"
          >
            Buscar
          </button>
          <button
            *ngIf="mostrarBotonEditar && !editando"
            class="btn btn-sm btn-secondary"
            (click)="editarPersona()"
          >
            Editar persona
          </button>
          <button
            id="limpiarCampos"
            *ngIf="mostrarBotonEditar && !editando"
            class="btn btn-sm btn-info ms-1"
            (click)="limpiarCampos()"
          >
            Limpiar Campos
          </button>
        </div>
        <div
          *ngIf="resultados['persona']?.length > 0"
          class="table-responsive resultados-autocompletar mt-2"
        >
          <table class="table table-striped table-bordered">
            <thead class="thead-light">
              <tr>
                <th>Apellido y Nombre</th>
                <th>Documento</th>
                <th>CUIL</th>
                <th>CUIL Titular</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let resultado of resultados['persona']"
                (click)="onSelectItem(resultado)"
              >
                <td>{{ resultado.apellido }} {{ resultado.nombre }}</td>
                <td>{{ resultado.documento }}</td>
                <td>{{ resultado.cuil }}</td>
                <td>{{ resultado.cuilTitular }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <br />

    <ul class="nav nav-tabs" id="tabMenu" role="tablist">
      <li class="nav-item" role="presentation">
        <button
          class="nav-link active"
          id="datos-personales-tab"
          data-bs-toggle="tab"
          data-bs-target="#datos-personales"
          type="button"
          role="tab"
          aria-controls="datos-personales"
          aria-selected="true"
        >
          Datos Personales
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button
          class="nav-link"
          id="datos-afiliacion-tab"
          data-bs-toggle="tab"
          data-bs-target="#datos-afiliacion"
          type="button"
          role="tab"
          aria-controls="datos-afiliacion"
          aria-selected="false"
        >
          Datos Afiliación
        </button>
      </li>
      <li class="nav-item" role="presentation" *ngIf="mostrarTabla">
        <button
          class="nav-link"
          id="datos-adherentes-tab"
          data-bs-toggle="tab"
          data-bs-target="#datos-adherentes"
          type="button"
          role="tab"
          aria-controls="datos-adherentes"
          aria-selected="false"
        >
          Datos Adherentes
        </button>
      </li>
      <button
        class="btn buttonCustom1 btn-sm ms-auto"
        (click)="verTitular()"
        *ngIf="
          personaSeleccionada.cuilTitular &&
          !personaSeleccionada?.parentesco.descripcion
            ?.toLowerCase()
            .includes('titular')
        "
        [disabled]="!personaSeleccionada.cuilTitular"
      >
        Ver titular
      </button>
    </ul>

    <div class="tab-content mt-3">
      <!-- Datos Personales -->
      <div
        class="tab-pane fade show active"
        id="datos-personales"
        role="tabpanel"
        aria-labelledby="datos-personales-tab"
      >
        <div class="container">
          <!-- Row 1: Nombre, Apellido, Documento y CUIL -->
          <div class="row">
            <div class="col-lg-3 col-md-6 col-12">
              <label class="resaltar-texto">Nombre:</label>
              <input
                type="text"
                class="form-control"
                [class.readonlyColor]="!editando"
                [readonly]="!editando"
                [(ngModel)]="personaSeleccionada.nombre"
              />
              <div *ngIf="errores['nombre']" class="text-danger">
                {{ errores["nombre"] }}
              </div>
            </div>
            <div class="col-lg-3 col-md-6 col-12">
              <label class="resaltar-texto">Apellido:</label>
              <input
                type="text"
                class="form-control"
                [class.readonlyColor]="!editando"
                [(ngModel)]="personaSeleccionada.apellido"
                [readonly]="!editando"
              />
              <div *ngIf="errores['apellido']" class="text-danger">
                {{ errores["apellido"] }}
              </div>
            </div>
            <div class="col-lg-3 col-md-6 col-12">
              <label class="resaltar-texto">Documento:</label>
              <input
                type="text"
                class="form-control"
                [class.readonlyColor]="!editando"
                [(ngModel)]="personaSeleccionada.documento"
                [readonly]="!editando"
              />
              <div *ngIf="errores['documento']" class="text-danger">
                {{ errores["documento"] }}
              </div>
            </div>
            <div class="col-lg-3 col-md-6 col-12">
              <label class="resaltar-texto">CUIL:</label>
              <input
                type="text"
                class="form-control"
                [class.readonlyColor]="
                  !editando ||
                  personaSeleccionada?.parentesco.descripcion
                    ?.toLowerCase()
                    .includes('titular')
                "
                [(ngModel)]="personaSeleccionada.cuil"
                [readonly]="
                  !editando ||
                  personaSeleccionada?.parentesco.descripcion
                    ?.toLowerCase()
                    .includes('titular')
                "
              />
              <div *ngIf="errores['cuil']" class="text-danger">
                {{ errores["cuil"] }}
              </div>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-lg-3 col-md-6 col-12">
              <label class="resaltar-texto">CUIL Titular:</label>
              <input
                type="text"
                class="form-control"
                [class.readonlyColor]="!editando"
                [(ngModel)]="personaSeleccionada.cuilTitular"
                [readonly]="!editando"
              />
              <div *ngIf="errores['cuilTitular']" class="text-danger">
                {{ errores["cuilTitular"] }}
              </div>
            </div>
            <div class="col-lg-3 col-md-6 col-12">
              <label class="resaltar-texto">Fecha Nacimiento:</label>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  [(ngModel)]="personaSeleccionada.fechaNacimiento"
                  ngbDatepicker
                  #d="ngbDatepicker"
                  [ngModelOptions]="{ standalone: true }"
                  [maxDate]="maxDate"
                  [minDate]="minDate"
                  [disabled]="!editando"
                  (input)="onFechaInput($event, d)"
                  placeholder="DD/MM/YYYY"
                  maxlength="10"
                />
                <button
                  class="btn btn-outline-secondary bi bi-calendar3"
                  (click)="d.toggle()"
                  type="button"
                  [disabled]="!editando"
                ></button>
              </div>
              <div *ngIf="errores['fechaNacimiento']" class="text-danger">
                {{ errores["fechaNacimiento"] }}
              </div>
            </div>
            <div class="col-lg-3 col-md-6 col-12">
              <label class="resaltar-texto">Teléfono:</label>
              <input
                type="text"
                class="form-control"
                [class.readonlyColor]="!editando"
                [(ngModel)]="personaSeleccionada.telefono"
                [readonly]="!editando"
              />
              <div *ngIf="errores['telefono']" class="text-danger">
                {{ errores["telefono"] }}
              </div>
            </div>
            <div class="col-lg-3 col-md-6 col-12">
              <label class="resaltar-texto">Sexo:</label>
              <select
                class="form-control"
                [(ngModel)]="personaSeleccionada.sexo.id"
                [disabled]="!editando"
              >
                <option *ngFor="let sexo of sexos" [ngValue]="sexo.id">
                  {{ sexo.descripcion }}
                </option>
              </select>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-lg-3 col-md-6 col-12">
              <label class="resaltar-texto">Parentesco:</label>
              <select
                class="form-control"
                [disabled]="!editando"
                [(ngModel)]="personaSeleccionada.parentesco.id"
              >
                <option
                  *ngFor="let parentesco of parentescos"
                  [value]="parentesco.id"
                >
                  {{ parentesco.descripcion }}
                </option>
              </select>
            </div>
            <div class="col-lg-3 col-md-6 col-12">
              <label class="resaltar-texto">Nacionalidad:</label>
              <select
                class="form-control"
                [disabled]="!editando"
                [(ngModel)]="personaSeleccionada.nacionalidad.id"
              >
                <option
                  *ngFor="let nacionalidad of nacionalidades"
                  [value]="nacionalidad.id"
                >
                  {{ nacionalidad.descripcion }}
                </option>
              </select>
            </div>
            <div class="col-lg-3 col-md-6 col-12">
              <label class="resaltar-texto">Provincia:</label>
              <select
                class="form-control"
                [disabled]="!editando"
                [ngModel]="personaSeleccionada?.localidad.provincia?.id"
                (ngModelChange)="
                  personaSeleccionada.localidad.provincia.id = $event
                "
                (change)="onProvinciaChange($event)"
              >
                <option
                  *ngFor="let provincia of provincias"
                  [value]="provincia.id"
                >
                  {{ provincia.descripcion }}
                </option>
              </select>
            </div>
            <div class="col-lg-3 col-md-6 col-12">
              <label class="resaltar-texto">Localidad:</label>
              <select
                class="form-control"
                [disabled]="!editando"
                [(ngModel)]="personaSeleccionada.localidad.id"
              >
                <option
                  *ngFor="let localidad of localidades"
                  [value]="localidad.id"
                >
                  {{ localidad.descripcion }}
                </option>
              </select>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-lg-3 col-md-6 col-12">
              <label class="resaltar-texto">Domicilio:</label>
              <input
                type="text"
                class="form-control"
                [class.readonlyColor]="!editando"
                [(ngModel)]="personaSeleccionada.nombreDomicilio"
                [readonly]="!editando"
              />
              <div *ngIf="errores['nombreDomicilio']" class="text-danger">
                {{ errores["nombreDomicilio"] }}
              </div>
            </div>
            <div class="col-lg-3 col-md-6 col-4">
              <label class="resaltar-texto">Nro:</label>
              <input
                type="text"
                class="form-control"
                [class.readonlyColor]="!editando"
                [(ngModel)]="personaSeleccionada.numeroDomicilio"
                [readonly]="!editando"
              />
              <div *ngIf="errores['numeroDomicilio']" class="text-danger">
                {{ errores["numeroDomicilio"] }}
              </div>
            </div>
            <div class="col-lg-3 col-md-6 col-4">
              <label class="resaltar-texto">Piso:</label>
              <input
                type="text"
                class="form-control"
                [class.readonlyColor]="!editando"
                [(ngModel)]="personaSeleccionada.piso"
                [readonly]="!editando"
              />
            </div>
            <div class="col-lg-3 col-md-6 col-4">
              <label class="resaltar-texto">Depto:</label>
              <input
                type="text"
                class="form-control"
                [class.readonlyColor]="!editando"
                [(ngModel)]="personaSeleccionada.departamento"
                [readonly]="!editando"
              />
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-12">
              <label class="resaltar-texto me-2">Activo:</label>
              <input
                type="checkbox"
                class="form-check-input"
                [checked]="personaSeleccionada?.activo === 1"
                [disabled]="!editando"
                (change)="onCheckboxChange($event)"
              />
            </div>
          </div>
        </div>
      </div>

      <div
        class="tab-pane fade"
        id="datos-afiliacion"
        role="tabpanel"
        aria-labelledby="datos-afiliacion-tab"
      >
        <!-- (Se puede ajustar similarmente si se requiere agrupar inputs) -->
        <div class="row">
          <div class="col-lg-3 col-md-6 col-12">
            <label class="resaltar-texto">Plan:</label>
            <select
              class="form-control"
              [disabled]="
                !editando ||
                !personaSeleccionada?.parentesco.descripcion
                  ?.toLowerCase()
                  .includes('titular')
              "
              [(ngModel)]="personaSeleccionada.plan.id"
            >
              <option *ngFor="let plan of planes" [ngValue]="plan.id">
                {{ plan.descripcion }}
              </option>
            </select>
          </div>
          <div class="col-lg-3 col-md-6 col-12">
            <label class="resaltar-texto">Obra Social:</label>
            <select
              class="form-control"
              [disabled]="
                !editando ||
                !personaSeleccionada?.parentesco.descripcion
                  ?.toLowerCase()
                  .includes('titular')
              "
              [(ngModel)]="personaSeleccionada.obraSocial.id"
            >
              <option
                *ngFor="let obraSocial of obrasSociales"
                [value]="obraSocial.id"
              >
                {{ obraSocial.descripcion }}
              </option>
            </select>
          </div>
          <div class="col-lg-3 col-md-6 col-12">
            <label class="resaltar-texto">Tipo Beneficiario:</label>
            <select
              class="form-control"
              [disabled]="
                !editando ||
                !personaSeleccionada?.parentesco.descripcion
                  ?.toLowerCase()
                  .includes('titular')
              "
              [(ngModel)]="personaSeleccionada.tipoBeneficiario.id"
            >
              <option
                *ngFor="let tipoBeneficiario of tiposBeneficiarios"
                [value]="tipoBeneficiario.id"
              >
                {{ tipoBeneficiario.descripcion }}
              </option>
            </select>
          </div>
          <div class="col-lg-3 col-md-6 col-12">
            <label class="resaltar-texto">Revista:</label>
            <select
              class="form-control"
              [disabled]="
                !editando ||
                !personaSeleccionada?.parentesco.descripcion
                  ?.toLowerCase()
                  .includes('titular')
              "
              [(ngModel)]="personaSeleccionada.revista.id"
            >
              <option *ngFor="let revista of revistas" [ngValue]="revista.id">
                {{ revista.descripcion }}
              </option>
            </select>
          </div>
          <div class="col-lg-3 col-md-6 col-12">
            <label class="resaltar-texto">Aporte Inicial:</label>
            <input
              type="number"
              class="form-control"
              [(ngModel)]="personaSeleccionada.aporteInicial"
              [readonly]="
                !editando ||
                !personaSeleccionada?.parentesco.descripcion
                  ?.toLowerCase()
                  .includes('titular')
              "
              [class.readonlyColor]="
                !editando ||
                !personaSeleccionada?.parentesco.descripcion
                  ?.toLowerCase()
                  .includes('titular')
              "
              min="0"
              step="0.01"
            />
            <div *ngIf="errores['aporteInicial']" class="text-danger">
              {{ errores["aporteInicial"] }}
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-12">
            <label class="resaltar-texto">Fecha Venta:</label>
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                [(ngModel)]="personaSeleccionada.fechaVenta"
                ngbDatepicker
                #fv="ngbDatepicker"
                [ngModelOptions]="{ standalone: true }"
                [disabled]="!editando"
                (input)="onFechaInput($event, fv)"
                placeholder="DD/MM/YYYY"
                maxlength="10"
              />
              <button
                class="btn btn-outline-secondary bi bi-calendar3"
                (click)="fv.toggle()"
                type="button"
                [disabled]="!editando"
              ></button>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-12">
            <label class="resaltar-texto">Vendedor:</label>
            <div class="input-group">
              <select
                class="form-control"
                [disabled]="!editando"
                [ngModel]="personaSeleccionada.vendedor?.id"
                (ngModelChange)="actualizarIdVendedor($event)"
                (click)="actualizarListaVendedores()"
              >
                <option value="" disabled selected>
                  Seleccione un vendedor
                </option>
                <option
                  *ngFor="let vendedor of vendedores"
                  [value]="vendedor.id"
                >
                  {{ vendedor.apellido }}, {{ vendedor.nombre }} ({{
                    vendedor.canalVenta
                  }})
                </option>
              </select>
              <button
                class="btn btn-outline-secondary"
                type="button"
                [disabled]="!editando"
                (click)="abrirModalVendedor()"
                title="Agregar nuevo vendedor"
              >
                <i class="fas fa-plus"></i>
              </button>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-12">
            <label class="resaltar-texto">Empresa principal:</label>
            <div>
              <div class="dropdown position-relative" ngbDropdown>
                <div class="input-group">
                  <button
                    class="form-control text-start d-flex justify-content-between align-items-center dropdown-toggle text-truncate"
                    type="button"
                    ngbDropdownToggle
                    [id]="'empresaDropdown'"
                    [disabled]="
                      !editando ||
                      !personaSeleccionada?.parentesco.descripcion
                        ?.toLowerCase()
                        .includes('titular')
                    "
                  >
                    <span
                      *ngIf="empresaSeleccionada"
                      class="text-truncate me-2"
                    >
                      {{ empresaSeleccionada.razonSocial }} ({{
                        empresaSeleccionada.cuit
                      }})
                    </span>
                    <span *ngIf="!empresaSeleccionada">
                      Seleccione una empresa
                    </span>
                  </button>
                  <button
                    class="btn btn-outline-secondary"
                    type="button"
                    [disabled]="
                      !editando ||
                      !personaSeleccionada?.parentesco.descripcion
                        ?.toLowerCase()
                        .includes('titular')
                    "
                    (click)="abrirModalEmpresa()"
                    title="Agregar nueva empresa"
                  >
                    <i class="fas fa-plus"></i>
                  </button>
                </div>
                <div
                  ngbDropdownMenu
                  [attr.aria-labelledby]="'empresaDropdown'"
                  class="dropdown-menu w-100 empresa-dropdown-menu"
                >
                  <div class="px-3 py-2">
                    <input
                      type="text"
                      class="form-control mb-2"
                      placeholder="Buscar por razón social o CUIT (mínimo 3 caracteres)"
                      [(ngModel)]="empresaFiltro"
                      (input)="filtrarEmpresas()"
                      (click)="$event.stopPropagation()"
                    />
                  </div>
                  <div class="dropdown-divider"></div>
                  <div
                    *ngIf="empresaFiltro.length < 3"
                    class="px-3 py-2 text-muted"
                  >
                    Escriba al menos 3 caracteres para buscar
                  </div>
                  <div
                    *ngIf="
                      empresaFiltro.length >= 3 && empresaFiltrada.length === 0
                    "
                    class="px-3 py-2 text-warning"
                  >
                    No se encontraron empresas con ese filtro
                  </div>
                  <div
                    class="dropdown-items-container"
                    *ngIf="empresaFiltrada.length > 0"
                  >
                    <button
                      *ngFor="let empresa of empresaFiltrada"
                      class="dropdown-item"
                      type="button"
                      (click)="onEmpresaSeleccionada(empresa.cuit)"
                    >
                      {{ empresa.razonSocial }} ({{ empresa.cuit }})
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <!-- Añadir en la pestaña datos-afiliacion, después del campo de Aporte Inicial -->
          <div class="col-lg-3 col-md-6 col-12">
            <div class="form-check mt-4">
              <input
                type="checkbox"
                class="form-check-input"
                id="planFijo"
                [disabled]="
                  !editando ||
                  !personaSeleccionada?.parentesco.descripcion
                    ?.toLowerCase()
                    .includes('titular')
                "
                [(ngModel)]="personaSeleccionada.planFijo"
              />
              <label class="form-check-label resaltar-texto" for="planFijo">
                Plan Fijo
              </label>
            </div>
          </div>
        </div>
      </div>

      <div
        class="tab-pane fade"
        id="datos-adherentes"
        role="tabpanel"
        aria-labelledby="datos-adherentes-tab"
      >
        <h2>Adherentes</h2>
        <div
          class="table-responsive"
          [ngClass]="{ 'd-none': !mostrarTabla || !tieneAdherentes }"
        >
          <table id="tablaPersonas" class="table table-striped table-bordered">
            <thead class="thead-light">
              <tr>
                <th>Apellido y Nombre</th>
                <th>Documento</th>
                <th>CUIL</th>
                <th>Parentesco</th>
                <th>F. Nacimiento</th>
                <th>Sexo</th>
                <th>Estado</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody></tbody>
          </table>
        </div>
        <div *ngIf="!tieneAdherentes">Sin adherentes</div>
        <button
          *ngIf="
            personaSeleccionada?.parentesco.descripcion
              ?.toLowerCase()
              .includes('titular')
          "
          class="btn btn-primary mt-3"
          (click)="agregarAdherente()"
          data-bs-toggle="modal"
          data-bs-target="#nuevoPersonaModal"
        >
          Agregar adherentes
        </button>
      </div>
    </div>
    <div class="mt-3" *ngIf="editando">
      <button class="btn btn-success me-2" (click)="guardarCambios()">
        Guardar cambios
      </button>
      <button class="btn btn-secondary" (click)="cancelarEdicion()">
        Cancelar
      </button>
    </div>
  </div>
</div>
